<template>
  <el-row class="container">
    <el-col
      :span="24"
      class="header"
    >
      <el-col
        :span="8"
        class="logo"
        :class="'logo-width'"
      >
        <img src="./../../static/logo.png" />
      </el-col>
      <el-col
        :span="8"
        class="header"
      >
        <el-menu
          :default-active="$route.path"
          class="header"
          mode="horizontal"
          router
        >
          <template
            v-for="(item,index) in $router.options.routes"
            v-if="((!item.hidden) && (item.role === 'all')) || ((userRole === 'admin') && (item.role === 'admin'))"
          >
            <el-submenu
              :index="index+''"
              v-if="!item.leaf"
              :key="index"
            >
              <template slot="title">
                <i :class="item.iconCls"></i>{{item.name}}</template>
              <el-menu-item
                v-for="child in item.children"
                :index="child.path"
                :key="child.path"
                v-if="!child.hidden"
              >{{child.name}}</el-menu-item>
            </el-submenu>
            <el-menu-item
              v-if="item.leaf&&item.children.length>0"
              :index="item.children[0].path"
              :key="index"
            >
              <i :class="item.iconCls"></i>{{item.children[0].name}}
            </el-menu-item>
          </template>
        </el-menu>
      </el-col>
      <el-col
        :span="8"
        class="userinfo"
      >
        <el-dropdown trigger="hover">
          <!-- <span class="el-dropdown-link userinfo-inner"><img :src="this.sysUserAvatar" /> {{sysUserName}}</span> -->
          <span class="el-dropdown-link userinfo-inner"><img src="./../../static/user4.png" /> {{sysUserName}}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="showDialogPassword">Alterar senha</el-dropdown-item>
            <!-- <el-dropdown-item>2</el-dropdown-item> -->
            <el-dropdown-item
              divided
              @click.native="logout"
            >Sair</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>

    <!-- Dialog responsavel por mostrar o form de alteracao de senha -->
    <el-dialog
      v-if="dialogPasswordCreated"
      title="Alterar senha do usuário"
      :show-close="false"
      :visible.sync="dialogPasswordVisible"
      width="40%"
    >
      <el-form
        ref="formPassword"
        :model="formPassword"
        label-width="160px"
        size="mini"
      >
        <el-form-item label="Usuário">
          <el-input
            v-model="formPassword.user"
            :disabled="true"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="Senha Atual"
          prop="currentPassword"
          :rules="[{ required: true, message: 'Informe a senha atual', trigger: 'blur' }]"
        >
          <!-- Foi utilizada string "nops" no auto-complete pois o chrome ignora quando informado "off" -->
          <el-input
            type="password"
            v-model="formPassword.currentPassword"
            auto-complete="nops"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item
          label="Nova Senha"
          prop="newPassword"
          :rules="[{ required: true, message: 'Informe a nova senha', trigger: 'blur' }]"
        >
          <!-- Foi utilizada string "nops" no auto-complete pois o chrome ignora quando informado "off" -->
          <el-input
            type="password"
            v-model="formPassword.newPassword"
            auto-complete="nops"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item
          label="Confirme a Senha"
          prop="confirmPassword"
          :rules="[{ required: true, message: 'Informe a senha de confirmação', trigger: 'blur' }]"
        >
          <!-- Foi utilizada string "nops" no auto-complete pois o chrome ignora quando informado "off" -->
          <el-input
            type="password"
            v-model="formPassword.confirmPassword"
            auto-complete="nops"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="medium"
          @click="hideDialogPassword"
        >Cancelar</el-button>
        <el-button
          size="medium"
          type="primary"
          :loading=formPassword.sendLoading
          @click.native="changePassword('formPassword')"
        >Confirmar</el-button>
      </span>
    </el-dialog>

    <el-col
      :span="24"
      class="main"
    >
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col
            :span="24"
            class="breadcrumb-container"
          >
            <strong class="title">{{$route.name}}</strong>
            <el-breadcrumb
              separator="/"
              class="breadcrumb-inner"
            >
              <el-breadcrumb-item
                v-for="item in $route.matched"
                :key="item.path"
              >
                {{ item.name }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <el-col
            :span="24"
            class="content-wrapper"
          >
            <transition
              name="fade"
              mode="out-in"
            >
              <router-view></router-view>
            </transition>
          </el-col>
        </div>
        <el-col
          :span="24"
          class="footer"
        >
          <div class="font">
            Powered by <a
              href="https://www.mrsistemas.com.br/"
              target="_blank"
            >MR Sistemas</a><br>
            © {{ (new Date().getFullYear()) }} MR SISTEMAS LTDA - Todos os Direitos reservados.
          </div>
        </el-col>
      </section>
    </el-col>
  </el-row>
</template>

<script>
import { Message } from "element-ui";
import { apiDeleteAuth, apiChangePassword } from "../api/api";

export default {
  data () {
    return {
      sysName: "MR STORAGE",
      sysUserName: "",
      dialogPasswordCreated: false,
      dialogPasswordVisible: false,
      userRole: "user",
      formPassword: {
        user: "",
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
        sendLoading: false
      }

      // sysUserAvatar: "",
      // form: {
      //   name: "",
      //   region: "",
      //   date1: "",
      //   date2: "",
      //   delivery: false,
      //   type: [],
      //   resource: "",
      //   desc: ""
      // }
    };
  },
  methods: {
    logout () {
      const _this = this;
      this.$confirm("Tem certeza que deseja sair?", "Sair", {
        //type: 'warning'
      })
        .then(() => {
          // localStorage.removeItem("user");
          console.log('logout')
          apiDeleteAuth()
            .then(() => {
              console.log('ok')
            })
            .catch(error => {
              console.log(error)
            });

          _this.$router.push("/login");
        })
        .catch(() => { });
    },
    hideDialogPassword () {
      this.dialogPasswordVisible = false;
      this.dialogPasswordCreated = false;
    },
    showDialogPassword () {
      this.formPassword.user = this.sysUserName;
      this.formPassword.currentPassword = "";
      this.formPassword.newPassword = "";
      this.formPassword.confirmPassword = "";
      this.dialogPasswordCreated = true;
      this.dialogPasswordVisible = true;
    },
    changePassword (formPassword) {
      this.formPassword.sendLoading = true;
      this.$refs[formPassword].validate(valid => {
        if (valid) {
          let params = {};
          params["currentPassword"] = this.formPassword.currentPassword;
          params["newPassword"] = this.formPassword.newPassword;
          params["confirmNewPassword"] = this.formPassword.confirmPassword;
          apiChangePassword(params)
            .then(res => {
              this.formPassword.sendLoading = false;
              Message.success(res.message);
              this.hideDialogPassword();
            })
            .catch(error => {
              this.formPassword.sendLoading = false;
            });
        } else {
          this.formPassword.sendLoading = false;
          return false;
        }
      });
    }
  },
  mounted () {
    let user = localStorage.getItem("user");
    // var user = sessionStorage.getItem('user');
    if (user) {
      user = JSON.parse(user);
      this.userRole = user.role;
      this.sysUserName = user.nome || "";
      // this.sysUserAvatar = user.avatar || "";
    }
  }
};
</script>

<style scoped lang="scss">
@import "~scss_vars";

.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  .header {
    height: 60px;
    line-height: 60px;
    background: $color-primary;
    color: #fff;
    .userinfo {
      text-align: right;
      padding-right: 35px;
      float: right;
      .userinfo-inner {
        cursor: pointer;
        color: #000;
        // color:#fff;
        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 0px 10px 10px;
          float: right;
        }
      }
    }
    .logo {
      //width:230px;
      height: 60px;
      font-size: 22px;
      padding-left: 5px;
      padding-right: 5px;
      // border-color: rgba(238,241,146,0.3);
      // border-right-width: 1px;
      // border-right-style: solid;
      img {
        width: 200px;
        float: center;
        margin: 5px 10px 10px 5px;
      }
      .txt {
        color: #fff;
      }
    }
    .logo-width {
      width: 230px;
    }
  }
  .footer {
    height: 30px;
    line-height: 15px;
    background: $color-primary;
    text-align: center;
    font-size: 12px;
    float: center;
    color: #000;
    .font {
      color: #475669;
    }
  }
  a:link,
  a:visited {
    text-decoration: none;
    color: #475669;
  }
  a:hover {
    text-decoration: none;
    color: #475669;
  }
  .main {
    display: flex;
    // background: #324057;
    position: absolute;
    top: 60px;
    bottom: 0px;
    overflow: hidden;
    .content-container {
      // background: #f1f2f7;
      flex: 1;
      // position: absolute;
      // right: 0px;
      // top: 0px;
      // bottom: 0px;
      // left: 230px;
      overflow-y: scroll;
      padding: 20px;
      .breadcrumb-container {
        //margin-bottom: 15px;
        .title {
          width: 200px;
          float: left;
          color: #475669;
        }
        .breadcrumb-inner {
          float: right;
        }
      }
      .content-wrapper {
        background-color: #fff;
        box-sizing: border-box;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Home.vue